// removed by extract-text-webpack-plugin
module.exports = {"view-organizations-table":"view-organizations-table","ReactTable":"ReactTable","rt-table":"rt-table","rt-thead":"rt-thead","rt-tbody":"rt-tbody","-header":"-header","rt-tr-group":"rt-tr-group","rt-tr":"rt-tr","rt-th":"rt-th","rt-td":"rt-td","responsive-table-container":"responsive-table-container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/PendingRequest/EdgeFix.scss
// module id = 5548
// module chunks = 1